import React from "react";
import { useTranslation } from "react-i18next";
import image from "assests/about/2.jpg";
import line from "assests/about/mission-line.png";

const Vission = ({ data }) => {
  const { i18n } = useTranslation();
  return (
    <section
      className="py-24 xl:h-[100vh] default-bg relative"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div
        className={`h-full flex flex-col items-center justify-center xl:mx-auto py-6 xl:py-0  ${
          i18n.language === "ar"
            ? "px-[1.5rem] md:pr-[6.1rem] xl:pl-0"
            : " px-[1.5rem]  md:pl-[6.1rem] xl:pl-0"
        } xl:w-1/2 xxl:w-1/3 `}
      >
        <div className="bg-white/50 backdrop-blur-xl border border-white/40 z-[1000] rounded-lg p-6 xl:mb-32">
          <p
            className={`titles-font text-3xl text-primary capitalize mb-2titles-font text-3xl  text-primary capitalize mb-2 `}
          >
            {data?.title}
          </p>

          <p dangerouslySetInnerHTML={{ __html: data?.text }} />
        </div>
      </div>

      <div
        className={`hidden xl:block absolute ${
          i18n.language === "ar"
            ? "-left-[0px] xxl:-left-[17px]"
            : "-right-[0px] xxl:-right-[17px]"
        }  -top-10 z-[100]`}
      >
        <img src={line} alt="" />
      </div>
    </section>
  );
};

export default Vission;
